export default __webpack_public_path__ + "static/media/error_sound.19d5e99e.wav";